var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13C3 12.4477 3.44772 12 4 12H20C20.5523 12 21 12.4477 21 13C21 13.5523 20.5523 14 20 14H4C3.44772 14 3 13.5523 3 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7127 0.0421737C11.9001 -0.0140579 12.0999 -0.0140579 12.2873 0.0421737L22.2873 3.04217C22.5562 3.12283 22.7788 3.31275 22.9007 3.56556C23.0226 3.81837 23.0327 4.11079 22.9285 4.37139L20.9285 9.37139C20.7234 9.88417 20.1414 10.1336 19.6286 9.92848C19.1158 9.72336 18.8664 9.14139 19.0715 8.62861L20.6655 4.64368L12 2.04403L3.3345 4.64368L4.92848 8.62861C5.13359 9.14139 4.88417 9.72336 4.37139 9.92848C3.85861 10.1336 3.27664 9.88417 3.07152 9.37139L1.07152 4.37139C0.967282 4.11079 0.977361 3.81837 1.0993 3.56556C1.22124 3.31275 1.44381 3.12283 1.71265 3.04217L11.7127 0.0421737Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9C3 8.44772 3.44772 8 4 8H20C20.5523 8 21 8.44772 21 9V15C21 19.9703 16.9703 24 12 24C7.02972 24 3 19.9703 3 15V9ZM5 10V15C5 18.8657 8.13428 22 12 22C15.8657 22 19 18.8657 19 15V10H5Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/police.9993c6f71f33d9c9e6ae7f9c6372c5f4.svg";
export { ForwardRef as ReactComponent };